export default __webpack_public_path__ + "static/media/svg-6.0d5eafcf.svg";